import { useTranslation } from "react-i18next";
import { BookOpenCheck, GraduationCap, HandHeart, HeartPulse, ShieldCheck, Users } from "lucide-react";

const DonateBanner = () => {
  const { t } = useTranslation();

  const impactItems = [
    {
      icon: HeartPulse,
      title: t("donate.banner.impact.healthcare.title"),
      text: t("donate.banner.impact.healthcare.text"),
    },
    {
      icon: GraduationCap,
      title: t("donate.banner.impact.educationSkilling.title"),
      text: t("donate.banner.impact.educationSkilling.text"),
    },
    {
      icon: HandHeart,
      title: t("donate.banner.impact.dignityPrograms.title"),
      text: t("donate.banner.impact.dignityPrograms.text"),
    },
    {
      icon: ShieldCheck,
      title: t("donate.banner.impact.reliefResponse.title"),
      text: t("donate.banner.impact.reliefResponse.text"),
    },
  ];

  return (
    <section className="bg-white pt-12 pb-20 md:pt-16 md:pb-28">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.28em] text-[#9d1f1c]">
              {t("donate.banner.eyebrow")}
            </p>
            <h2 className="text-3xl font-semibold leading-tight text-[#14201f] md:text-5xl">
              {t("donate.banner.heading")}
            </h2>
            <p className="mt-6 text-base leading-8 text-[#52615f] md:text-lg">
              {t("donate.banner.description")}
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-2">
              <div className="rounded-lg border border-[#dfe8e6] p-5">
                <Users className="h-7 w-7 text-[#9d1f1c]" />
                <p className="mt-4 text-2xl font-semibold text-[#14201f]">{t("donate.banner.peopleFirst.title")}</p>
                <p className="mt-2 text-sm leading-7 text-[#52615f]">
                  {t("donate.banner.peopleFirst.text")}
                </p>
              </div>
              <div className="rounded-lg border border-[#dfe8e6] p-5">
                <BookOpenCheck className="h-7 w-7 text-[#9d1f1c]" />
                <p className="mt-4 text-2xl font-semibold text-[#14201f]">{t("donate.banner.vedantAnchored.title")}</p>
                <p className="mt-2 text-sm leading-7 text-[#52615f]">
                  {t("donate.banner.vedantAnchored.text")}
                </p>
              </div>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {impactItems.map(({ icon: Icon, title, text }) => (
              <div key={title} className="rounded-lg border border-[#dfe8e6] bg-[#f7faf9] p-6">
                <Icon className="h-7 w-7 text-[#9d1f1c]" />
                <h3 className="mt-5 text-xl font-semibold text-[#14201f]">{title}</h3>
                <p className="mt-3 text-sm leading-7 text-[#52615f]">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonateBanner;
